import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ContentWrapper } from "../../Material/create/Styled";
import BackButton from "../../../shared/components/BackButton";
import {
    CreateKpiCategoryTitleBar,
    CreateKpiRevenueTitleBar,
    kpiCreateCategoryFields,
    kpiCreateRevenueFields,
} from "../../../configs/kpi";
import Title from "./Title";
import useMergeState from "../../../shared/hooks/useMergeState";
import { SingleKpi } from "../single";
import { api } from "../../../shared/hooks/api";
import { error, success } from "../../../utils/toast";
import { WarningUnsavedChanges } from "../../../configs/warningProductModal";
import CancelModal from "../../../shared/components/CancelModal";

const initialKpiData = {
    name: "",
    type: "Category",
    status: "Open",
    duration_unit: "YEAR",
};

const CreateKpi = () => {
    const location = useLocation();
    const [type, setType] = useState("");
    const navigate = useNavigate();
    const [kpi, mergeKpi] = useMergeState(initialKpiData);
    const [validated, setValidated] = useState(false);
    const [{ isCreating }, createKpi] = api.post("/kpi/");
    const [isModified, setIsModified] = useState(false);
    const [showUnsavedDialog, setShowUnsavedDialog] = useState(false);
    const [navigationPath, setNavigationPath] = useState("");

    useEffect(() => {
        if (location.state) {
            setType(location.state.type);
            mergeKpi({ ...initialKpiData, type: location.state.type });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state]);

    console.log("type", type);

    const title = type === "Category" ? "Tạo chỉ tiêu danh mục" : "Tạo chỉ tiêu doanh thu";
    const createTitleButtonText =
        type === "Category" ? CreateKpiCategoryTitleBar : CreateKpiRevenueTitleBar;
    const kpiFields = type === "Category" ? kpiCreateCategoryFields : kpiCreateRevenueFields;

    useEffect(() => {
        if (type === "Category") {
            handleChangeKpiInfo({ type: "Category" });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);

    useEffect(() => {
        if (
            kpi.name ||
            kpi.status !== "Open" ||
            kpi.duration_unit !== "YEAR" ||
            kpi.type !== "Category"
        ) {
            setIsModified(true);
        }
    }, [kpi]);
    
    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (isModified) {
                e.preventDefault();
                e.returnValue = "";
                return "";
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [isModified]);

    const confirmNavigation = useCallback((path: string) => {
        if (isModified) {
            setNavigationPath(path);
            setShowUnsavedDialog(true);
            return false;
        }

        navigate(path);
        return true;
    }, [isModified, navigate]);

    const handleBackClick = () => {
        confirmNavigation("/kpis/");
    };

    const handleSaveAndNavigate = async () => {
        setShowUnsavedDialog(false);
        await handleSubmit();
    };

    const handleDontSaveAndNavigate = () => {
        setShowUnsavedDialog(false);
        navigate(navigationPath);
    };

    const handleContinueEditing = () => {
        setShowUnsavedDialog(false);
    };

    const handleSubmit = () => {
        createKpi(kpi)
            .then(() => {
                success("Thành Công", "Tạo mơi chỉ tiêu thành công");
                setIsModified(false);
                navigate(`/kpis/`);
                return true;
            })
            .catch((err: any) => {
                error("Lỗi tạo chỉ tiêu", err);
                return false;
            });
    };

    const handleChangeKpiInfo = (updateDate: any) => {
        setIsModified(true);
        mergeKpi({
            ...kpi,
            ...updateDate,
        });
    };

    return (
        <ContentWrapper>
            <BackButton label="Trở về" onClick={handleBackClick} />
            <Title
                title={title}
                setValidate={setValidated}
                submitForm={handleSubmit}
                createTitleButtonText={createTitleButtonText}
                isLoading={isCreating}
            />
            <SingleKpi
                kpi={kpi}
                mergeKpi={handleChangeKpiInfo}
                validated={validated}
                kpiFields={kpiFields}
            />
            <CancelModal
                open={showUnsavedDialog}
                handleConfirm={handleSaveAndNavigate}
                handleClose={handleDontSaveAndNavigate}
                handleCancel={handleContinueEditing}
                title={WarningUnsavedChanges.title}
                contentText={WarningUnsavedChanges.context}
                closeButtonText={WarningUnsavedChanges.closeButtonText}
                confirmButtonText={WarningUnsavedChanges.confirmButtonText}
                cancelButtonText={WarningUnsavedChanges.cancelButtonText}
                showCancelButton={true}
            />
        </ContentWrapper>
    );
};

export default CreateKpi;
